import React from 'react';
import styled from 'styled-components';

import { Flex } from '../atom/Layout';
import { Text } from '../atom/Text';
import InputWithIcon from '../molecules/InputWithIcon';

import { SizeToRem } from '../../../lib/style/ThemeStyle';

export const InputForm = ({
  state = { nameError: null, name: '' },
  formData = [
    { label: '', type: '', name: '', mainIconName: '', placeholder: '' },
  ],
  onChangeValue = undefined,
  onSubmit = undefined,
  size = 2,
  readOnlyState = [],
  children,
}) => {
  return (
    <Flex column alignItems="strecth" padding={`0 0 ${SizeToRem(20)}`}>
      {formData.map((data) => {
        const {
          label,
          mainIconName,
          placeholder,
          type,
          name,
          subIconName,
        } = data;
        return (
          <FormContainer key={name} column alignItems="strecth" size={size}>
            {label && <Text style={{ margin: '0.625rem 0' }}>{label}</Text>}
            <InputWithIcon
              mainIconName={mainIconName}
              subIconName={subIconName}
              placeholder={placeholder}
              type={type}
              value={state[name]}
              name={name}
              onChange={onChangeValue}
              active={state[`${name}Error`]}
              onKeyPress={(e) => e.key === 'Enter' && onSubmit && onSubmit()}
              size={size}
              readOnly={readOnlyState.includes(name)}
            />
            {state[`${name}Error`] && (
              <Text color="orangePink" size="14" style={{ marginTop: '5px' }}>
                *{state[`${name}Error`]}
              </Text>
            )}
          </FormContainer>
        );
      })}
      {children}
    </Flex>
  );
};

const FormContainer = styled(Flex)`
  & + & {
    margin-top: ${(props) => (props.size === 3 ? '0.938rem' : '0.625rem')};
  }
`;
